import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 15V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18H3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListMusic";
const ListMusic = memo(themed(Icon));
export {
  ListMusic
};
//# sourceMappingURL=list-music.js.map
